import styled from 'styled-components'

export const PricingListContainer = styled.div``

export const PricingListGrid = styled.div`
  display: grid;
  grid-template: 1fr / repeat(3, 1fr);
  grid-gap: 0 2.5rem;
  margin-bottom: 5rem;
`

export const PricingListTabs = styled.div<{ isHover: boolean }>`
  max-width: 300px;
  width: 90%;
  height: 2rem;
  border: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  border-radius: 1rem;
  margin: 0 auto 6.5rem auto;
  background-color: ${({ isHover, theme }) =>
    isHover ? theme.colors.backgroundGrayLigth : theme.colors.white};
  display: flex;
`

export const PricingListTabDiscount = styled.span`
  font-size: 0.65rem;
  line-height: 0.65rem;
  color: ${({ theme }) => theme.colors.secondary};
  transition: all 0.25s ease-in-out 0.1s;
`

export const PricingListTab = styled.button<{ active: boolean }>`
  appearance: none;
  border: none;
  outline: none;
  background: none;
  height: 100%;
  width: 100%;
  border-radius: 1rem;
  font-size: 0.85rem;
  line-height: 0.85rem;
  color: ${({ active, theme }) =>
    active ? theme.colors.white : theme.colors.primary};
  background-color: ${({ active, theme }) =>
    active ? theme.colors.primary : 'transparent'};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.main}, sans-serif;
  transition: all 0.25s ease-in-out;
  &:hover {
    color: ${({ active, theme }) =>
      active ? theme.colors.white : theme.colors.blackSecondary};
    background-color: ${({ active, theme }) =>
      active ? theme.colors.primaryAccent : theme.colors.backgroundGrayLigth};
    ${PricingListTabDiscount} {
      color: ${({ active, theme }) =>
        active ? theme.colors.white : theme.colors.blackSecondary};
    }
  }
  ${PricingListTabDiscount} {
    color: ${({ active, theme }) =>
      active ? theme.colors.white : theme.colors.secondary};
  }
`

export const PricingListCustom = styled.p`
  color: ${({ theme }) => theme.colors.fontMain};
  text-align: center;
  max-width: 80%;
  margin: 0 auto;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  span {
    color: ${({ theme }) => theme.colors.primary};
  }
`
export const PricingListCustomLink = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;
`
